import { render } from "./ColorChooserWindow.vue?vue&type=template&id=61cf9cb9&scoped=true"
import script from "./ColorChooserWindow.vue?vue&type=script&lang=js"
export * from "./ColorChooserWindow.vue?vue&type=script&lang=js"

import "./ColorChooserWindow.vue?vue&type=style&index=0&id=61cf9cb9&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-61cf9cb9"

export default script